import React from 'react'
import { isFlagOn, getShapeBorderStyle, getLineShapeStyle, resolveTextStyle } from '../../lib/global/helpers'

export default function HTMLFooterTemplate(props) {
    const pageSettings = {
        'a4': {
            'width': 794,
            'height': 1123
        },
        'letter': {
            'width': 595,
            'height': 842
        }
    };

    const renderUploadedImages = (section) => {
        const images = props.properties?.[section]?.images;
        if (!images) return null;

        return Object.keys(images).map((key) => {
            const data = images[key];
            if (!data || !data.src) return null;

            return (
                <div
                    key={data.id || key}
                    style={data.style}
                    id={data.id}
                    data-element={data.name}
                    data-section={section}
                    data-path="images"
                    data-index={key}
                >
                    <img
                        src={data.src}
                        alt={data.alt || data.name || ''}
                        style={{ width: '100%', height: '100%', display: 'block' }}
                    />
                </div>
            );
        });
    };

    const renderElements = (section) => {
        return (
            props.properties &&
            props.properties[section]?.elements &&
            Object.keys(props.properties[section].elements).map((key) => {
                var data = props.properties[section].elements[key];
                if (!data) return null;

                var dStyle = Object.assign({}, data.style || {});
                dStyle = resolveTextStyle(dStyle, props.properties[section]?.font, props.properties.prop);
                dStyle.left = dStyle.left ? parseInt(dStyle.left) * 0.75 : 0;
                dStyle.zIndex = 2;

                const dataIndex = data.name ? data.name.replace(/\./g, '') : (data.id || `element-${key}`);

                return (
                    <div
                        key={data.id || key}
                        style={dStyle}
                        id={data.id}
                        data-element={data.name || 'element'}
                        data-section={section}
                        data-path="elements"
                        data-index={dataIndex}
                    >
                        {data.text || ''}
                    </div>
                );
            })
        );
    };

    const renderShapes = () => {
        if (!props.properties.foot.shapes) return null;

        return Object.keys(props.properties.foot.shapes)
            .filter(s => s !== 'border')
            .map((key) => {
                var prop = props.properties.foot.shapes[key];
                if (!prop) return null;

                var sectionBorder = props.properties.foot.shapes.border || {};
                var isLine = prop.name && prop.name.startsWith('line');
                var bgColor = prop.fillColor || sectionBorder.fillColor || '#FFFFFFFF';

                var dStyle = Object.assign(isLine ? {} : { minWidth: '32px', minHeight: '16px' }, prop.style || {});
                if (isLine) {
                    Object.assign(dStyle, getLineShapeStyle(prop, sectionBorder));
                } else {
                    Object.assign(dStyle, getShapeBorderStyle(prop, sectionBorder));
                    dStyle.background = bgColor;
                }
                dStyle.left = dStyle.left ? parseInt(dStyle.left) * 0.75 : 0;
                dStyle.width = dStyle.width ? parseInt(dStyle.width) * 0.75 : 32;
                dStyle.top = dStyle.top ? parseInt(dStyle.top) : 0;
                dStyle.zIndex = 1;

                return (
                    <div
                        key={key}
                        style={dStyle}
                        id={prop.id}
                        data-element={prop.name || 'shape'}
                        data-section={"foot"}
                        data-path="shapes"
                        data-index={prop.data || key}
                    />
                );
            });
    };

    return (
        <div style={{ width: '100%', pageBreakInside: 'avoid', breakInside: 'avoid' }} className="foot" data-layout="footer-bottom-of-last-page" data-print-every-page={isFlagOn(props.properties.foot?.printingFooterEveryPage) ? "true" : "false"}>
            <div style={{
                height: props.properties.prop.orientation === "landscape"
                    ? props.heights.foot * 0.01 * pageSettings[props.properties.prop.paperSize]?.width
                    : props.heights.foot * 0.01 * pageSettings[props.properties.prop.paperSize]?.height,
                position: 'relative',
                backgroundColor: props.properties.foot.background.showColor
                    ? props.properties.foot.background.color
                    : "transparent",
            }}>
                <div>
                    {renderElements("foot")}
                    {renderShapes()}
                    {renderUploadedImages("foot")}
                </div>
            </div>
        </div>
    );
}